import produce, { Draft } from "immer";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  LOGGED_IN,
  LOGOUT,
  CHANGE_SITE,
  CREATE_ORGANISATION,
} from "../actions/action-types";
import { potionsLocalStorage } from "@localStorage";

export const initialState = {
  organisationId: potionsLocalStorage.organisationId,
  organisationName: potionsLocalStorage.organisationName ?? "",
};

export default function todosReducer(
  state = initialState,
  action: PayloadAction<Dic<any>>
) {
  return produce(state, (draft: Draft<typeof initialState>) => {
    switch (action.type) {
      case CHANGE_SITE:
        draft.organisationId = action.payload.organisationId;
        draft.organisationName = action.payload.organisationName;
        break;
      case LOGGED_IN:
        draft.organisationId = action.payload.organisationId;
        draft.organisationName = action.payload.organisationName;
        break;
      case LOGOUT:
        draft.organisationId = null;
        draft.organisationName = "";
        break;
      case CREATE_ORGANISATION:
        draft.organisationId = action.payload.organisationId;
        draft.organisationName = action.payload.organisationName;
        break;

      default:
        break;
    }
  });
}
